import PropTypes from "prop-types";
import React from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Button } from "reactstrap";
import { useState } from "react";

const Wizard = ({ tabs = [], onFinish, onNextTab, ocultarGuardar = false }) => {
    const [activeStep, setActiveStep] = useState("0");

    const toggleStep = (newActiveStep) => async () => {
        let canChangeTab = true;

        if (onNextTab != null) {
            canChangeTab =
                newActiveStep > activeStep ? await onNextTab(activeStep) : true;
        }

        if (activeStep != newActiveStep && canChangeTab) {
            setActiveStep(`${newActiveStep}`);
        }
    };

    return (
        <>
            <Nav pills justified={true}>
                {tabs.map((tab, index) => {
                    return (
                        <NavItem key={index} className="mb-3">
                            <NavLink
                                tag="div"
                                className={
                                    activeStep == index
                                        ? "bg-primary text-white"
                                        : ""
                                }
                                onClick={toggleStep(index)}
                            >
                                <h4 className="text-left my-3">
                                    {tab.nombre}
                                    <br />
                                    <small>{tab.descripcion}</small>
                                </h4>
                            </NavLink>
                        </NavItem>
                    );
                })}
            </Nav>
            <TabContent activeTab={activeStep} className="p-3">
                {tabs.map((tab, index) => {
                    return (
                        <TabPane
                            key={`tabPane-${index}`}
                            id={index}
                            tabId={`${index}`}
                        >
                            {tab.componente}
                            <div className="d-flex">
                                {activeStep > 0 ? (
                                    <Button
                                        onClick={toggleStep(index - 1)}
                                        color="secondary"
                                    >
                                        Anterior
                                    </Button>
                                ) : (
                                    ""
                                )}
                                {index < tabs.length - 1 ? (
                                    <Button
                                        className="ml-auto"
                                        color="primary"
                                        onClick={toggleStep(index + 1)}
                                    >
                                        Siguiente
                                    </Button>
                                ) : (
                                    ""
                                )}
                                {index == tabs.length - 1 && !ocultarGuardar ? (
                                    <Button
                                        className="ml-auto"
                                        color="primary"
                                        onClick={onFinish}
                                    >
                                        Guardar
                                    </Button>
                                ) : (
                                    ""
                                )}
                            </div>
                        </TabPane>
                    );
                })}
            </TabContent>
        </>
    );
};

Wizard.propTypes = {
    tabs: PropTypes.array,
    onFinish: PropTypes.func,
    onNextTab: PropTypes.func,
    ocultarGuardar: PropTypes.bool,
};

export default Wizard;
